import './TrackMap.css'
import React, {useEffect, useState} from "react";
import {Coordinate} from "../../../models/Coordinate";
import {GoogleMap, Marker, Polyline, useJsApiLoader} from '@react-google-maps/api';
import iphone_icon from '../../../assets/iphone_icon.png'

interface ILeaderLocationResponse {
    location: Coordinate
    coordinates: Coordinate[]
    locationOnRoute: Coordinate
    kmToGo: number
}

interface ITrackMap {
    comp: number;
    showMap: boolean
    setDistanceHandler: (distance: number | null) => void
    autoCenter: boolean
    showIphone: boolean
}

let timeout: NodeJS.Timeout | undefined = undefined;

export default function TrackMap(props: ITrackMap) {
    const {comp} = props
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyAYiGROZhOlKdM4NS3g813ZoCuD4JHUnic"
    })

    const [map, setMap] = useState<google.maps.Map | null>(null)
    const onLoad = React.useCallback(function callback(map) {
        setMap(map)
    }, [])
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])
    const [coordinates, setCoordinates] = useState<Coordinate[]>([])
    const [leaderLocation, setLeaderLocation] = useState<Coordinate>(new Coordinate(31.9012474548072, 35.0122970994562, null))
    const [iphoneLocation, setIphoneLocation] = useState<Coordinate>(new Coordinate(31.9012474548072, 35.0122970994562, null))

    const [render, setRender] = useState(1)

    const containerStyle = {
        width: 'calc(480px)',
        height: '500px',
        maxHeight: '100%',
        marginRight: '20px',
    };

    const setRequestTimeout = () => {
        if(timeout) {
            clearTimeout(timeout)
            timeout = undefined;
        }
        timeout = setTimeout(() => setRender((render) => render + 1) , 5000)
    }

    useEffect(() => {
        fetch(`https://www.4sport-live.com/epic/getLeaderLocation?comp=${comp}`)
            .then(res => res.json())
            .then(
                (response: ILeaderLocationResponse) => {
                    setCoordinates(response.coordinates.map(coordinate => new Coordinate(coordinate.lat, coordinate.lng, coordinate.siduri)))
                    setLeaderLocation(new Coordinate(response.locationOnRoute.lat, response.locationOnRoute.lng, null))
                    setIphoneLocation(new Coordinate(response.location.lat, response.location.lng, null))
                    props.setDistanceHandler(response.kmToGo)
                    setRequestTimeout()
                },
                (error) => {
                    setRequestTimeout()
                    console.log(error)
                }
            ).catch((error: any) => {
            setRequestTimeout()
            console.log(error)
        })
    }, [render])


    const center = (map != null && !props.autoCenter) ? map.getCenter() : leaderLocation

    return isLoaded && leaderLocation && props.showMap ? (
        <>
            <br/>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={17}
                onLoad={onLoad}
                onUnmount={onUnmount}
            >
                <Marker position={leaderLocation} />
                {props.showIphone && <Marker icon={iphone_icon} position={iphoneLocation} />}

                <Polyline
                    path={coordinates}
                    options={{
                        strokeColor: '#0000ff',
                        strokeOpacity: 1,
                        strokeWeight: 5,
                    }}
                />
            </GoogleMap>
        </>
    ) : <></>
}